import React from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar'
function totalEffortRequired(items){
  var totalEffort =0;
  for(var i=0;i<items.length;i++){
    var currentEffort = items[i].taskDetails.effort;
    if(currentEffort === 'HIGH'){
      totalEffort+=120;
    }else if(currentEffort === 'MEDIUM'){
      totalEffort+=45;
    }else
      totalEffort+=15;
  }
  return totalEffort;
}
/*
function getCompletedItems(allItems){
  var now = new Date();
  
  return allItems.filter(item=>{
    if(item.taskDetails.completedDate !==null){
    var reminderTime = new Date(item.taskDetails.completedDate);
  if (reminderTime.getFullYear() === now.getFullYear()
    && reminderTime.getDate() === now.getDate()
    && reminderTime.getMonth() === now.getMonth())
    return true;
    }
    return false;

  });
} */
function EffortProgress(props) {
  var items = props.items;
  var totalEffort = totalEffortRequired(items);
  var type ="success";
  var percent = totalEffort/150*100;
  /* var completedItems = getCompletedItems(props.allItems);
  var completedEffort = 0;
 if(completedItems!==null && completedItems.length>0){
    completedEffort = totalEffortRequired(completedItems);
  }
  var completedPercent = completedEffort/(completedEffort+totalEffort)*100;
  */
 if(percent>100){
    type ="danger"
  }else if(percent>70)
    type="warning";
  return ( <>
  <ProgressBar animated label={`${props.areawiseCompletedEffort}% Completed`} now={props.areawiseCompletedEffort}></ProgressBar>
  <ProgressBar striped label={`${props.areawiseEffort}% Effort=${totalEffort}`} variant={type} now={props.areawiseEffort}></ProgressBar>
  
  </>);
}
export default EffortProgress;
